// extracted by css-extract-rspack-plugin
export default {"helperText":"E2UwzkcC_4IIqWS6"};